import * as microwaves from './list'

import { Microwave } from 'app/types/machines/microwave'

export const allMicrowaves: Microwave[] = Object.values(microwaves).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
